function productCostBasisComplete(summary) {
    return summary?.purchaseCostComplete !== false
        && Number(summary?.purchaseCostUnknownCount ?? 0) === 0;
}

export function productPurchaseCostQuality(summary) {
    const unknownProductRows = Math.max(0, Number(summary?.purchaseCostUnknownCount ?? 0));
    const unresolvedOrders = Math.max(0, Number(summary?.unresolvedPurchaseCostOrderCount ?? 0));

    return {
        complete: summary?.purchaseCostComplete !== false && unknownProductRows === 0 && unresolvedOrders === 0,
        unknownProductRows,
        unresolvedOrders,
        estimatedRows: Math.max(0, Number(summary?.purchaseCostEstimatedCount ?? 0)),
    };
}

export function productGoodsMarginAvailable(summary) {
    return productCostBasisComplete(summary) && summary?.grossMargin != null;
}

export function productMarketingAllocationAvailable(summary) {
    return summary?.marketingAllocationComplete !== false
        && summary?.allocatedMarketingSpend != null;
}

export function productAfterMarketingProfitAvailable(summary) {
    return productCostBasisComplete(summary)
        && productMarketingAllocationAvailable(summary)
        && summary?.profitAfterMarketing != null;
}

export function productRowGoodsMarginAvailable(product) {
    return product?.purchaseCostComplete === true && product?.grossMargin != null;
}

export function productRowMarketingAllocationAvailable(summary, product) {
    return summary?.marketingAllocationComplete !== false
        && product?.allocatedMarketingSpend != null;
}
